<template>
  <!-- 搜索 -->
  <div id="Search">
    <Header></Header>
    <Navigate></Navigate>
    <div class="content">
      <div class="crumbs">
        <span
          >您搜索的“{{ this.$route.query.Title }}”共有
          {{ this.page.total }} 个结果</span
        >
      </div>
      <div class="content_body_none" v-if="!this.results">
        <!-- <div class="zwIcon">
          <i class="iconfont icon-wusousuojieguo"></i>
        </div> -->
        <div class="zwSpan">
          <p>抱歉，暂时没有找到相关内容</p>
          <p>建议您检查关键词后，重新输入</p>
        </div>
      </div>
      <div class="content_body" v-else>
        <li
          v-for="(item, index) in results"
          :key="index"
          @click="todetail(item)"
        >
          <p style="font-size:18px;color:#000;" v-html="item.Title"></p>
          <p v-html="item.Abstruct"></p>
          <p>
            <span>{{ item.AddDate }}</span>
          </p>
        </li>
        <el-pagination
          background
          class="r"
          @size-change="handleSizeChange"
          @current-change="handleCurrentPageChange"
          :current-page="page.currentPage"
          :page-sizes="page.sizes"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/public/heade/index";
import Navigate from "@/components/public/navigation/index";
import Foot from "@/components/public/foot/index";
import BannerLeft from "@/components/public/bannerLeft/index";
import axios from "axios";
import { pagination } from "../../../src/assets/mixin/data-table";
export default {
  name: "Search",
  mixins: [pagination],
  data() {
    return {
      SearchList: [],
      timer: "",
      results: [],
    };
  },
  methods: {
    todetail(item) {
      this.$router.push({
        path: "/Search/Searchdetail",
        query: {
          id: item.ContentID,
        },
      });
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    getInfo() {
      this.page.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      axios
        .post("/SiteContentAPI/GetPageListByKeyWords", {
          Title: this.$route.query.Title,
          JournalID: 202007100001,
          CurrentPage: this.page.currentPage,
          PageSize: this.page.pageSize,
        })
        .then((res) => {
          this.page.total = res.data.totalRecords;
          this.changeColor(res.data._itemList);
        });
    },
    handleCurrentPageChange(val) {
      this.page.currentPage = val;
      this.getTableData();
    },
    changeColor(SearchList) {
      SearchList.map((item, index) => {
        if (this.$route.query.Title && this.$route.query.Title.length > 0) {
          // 匹配关键字正则
          let replaceReg = new RegExp(this.$route.query.Title, "g");
          // 高亮替换v-html值
          let replaceString =
            '<span class="search-text">' + this.$route.query.Title + "</span>";
          SearchList[index].Abstruct = item.Title.replace(
            replaceReg,
            replaceString
          );
          SearchList[index].Title = item.Title.replace(
            replaceReg,
            replaceString
          );
        }
        item.AddDate = item.AddDate.substr(0, 10);
      });
      this.results = [];
      this.results = SearchList;
    },
  },
  created() {
    this.getInfo();
   
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route(to, from) {
      //做一些路由变化的响应
      //打开加载动画
      this.loading = true;
      if(this.$route.query.Title){
        this.getTableData()
      }
      //重新获取数据
      // this.getInfo();
      /** 初始化其他数据 */
    },
  },
  components: {
    Header,
    Navigate,
    Foot,
    BannerLeft,
  },
};
</script>

<style lang="less" scoped>
#Search {
  width: 100%;
  height: auto;
  // margin: 0 auto;
  // position: relative;
  // margin-bottom:25px;
  .content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    margin-bottom: 115px;
    .crumbs {
      width: 1200px;
      height: 20px;
      position: relative;
      text-align: left;
      margin: 0 auto;
      margin-top: 24px;
      margin-left: 2%;
      line-height: 20px;
      span:nth-child(1) {
        color: #c01b22;
        font-size: 16px;
        margin-left: 10px;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .content_body_none {
      width: 100%;
      height: 100%;
      margin-top: 30px;
      // .zwIcon{
      //   width:81px;
      //   height:84px;
      //   float:left;
      //   i{
      //     color:#0368B8;
      //     font-size:77px;
      //     position: relative;
      //     top: -15px;
      //   }
      // }
      .zwSpan {
        width: 100%;
        height: 60px;
        margin-left: 24px;
        text-align: center;
        p:nth-child(1) {
          color: #0368b8;
          font-size: 22px;
        }
        p:nth-child(2) {
          color: #000000;
          font-size: 16px;
          margin-top: 10px;
        }
      }
    }
    .content_body {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      margin-top: 26px;
      position: relative;
      margin-bottom: 25px;
      li:hover {
        p:nth-child(1) {
          a {
            color: #c01b22;
          }
        }
        background: #f7f8fa;
      }
      li {
        list-style: none;
        border-bottom: 1px solid #e6e6e6;
        width: 100%;
        height: auto;
        cursor: pointer;
        padding: 15px 9px;
        background: #fff;
        p:nth-child(1) {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
          a {
            color: #000000;
            font-size: 18px;
          }
        }
        p:nth-child(2) {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          color: #8b8b8b;
          font-size: 16px;
          margin-top: 7px;
          text-align: justify;
          /deep/p {
            /deep/span {
              font-size: 14px !important;
            }
          }
        }
        p:nth-child(3) {
          width: 100%;
          height: 15px;
          margin-top: 9px;
          span {
            color: #8b8b8b;
            font-size: 15px;
          }
        }
      }
    }
  }
}
/deep/.search-text {
  color: #c01b22 !important;
  font-weight: bold;
}
/deep/.el-pagination {
  position: absolute;
  bottom: -46px;
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Search/index.vue